export default {
  data() {
    return {
      editUserForm: {
        firstName: '',
        lastName: '',
        mobilrNum: '',
        emailId: '',
        password: '',
      },
      editUserFormRules: {
        firstName: [{ required: true, message: 'First name is required', trigger: 'blur' }],
        lastName: [{ required: true, message: 'Last name is required', trigger: 'blur' }],
        emailId: [
          { required: true, message: 'Email is required', trigger: 'blur' },
          {
            type: 'email',
            message: 'Please enter a valid email address',
            trigger: ['blur', 'change'],
          },
        ],
        mobileNumber: [
          { required: true, message: 'Mobile number is required', trigger: 'blur' },
          {
            pattern: /^\+?\d{1,4}[-\s]?\d{10,15}$/,
            message: 'Please enter a valid mobile number',
            trigger: 'blur',
          },
        ],
        password: [
          { required: true, message: 'Password is required', trigger: 'blur' },
          {
            pattern: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
            message:
              'Password must have at least 8 characters with one letter, one number, and one special character',
            trigger: 'blur',
          },
        ],
      },
    };
  },
  methods: {
    saveEditForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$router.push({ name: 'user-details' });
          console.log('Form submitted:', this.editUserForm);
        } else {
          console.error('Validation failed');
        }
      });
    },
    cancelEditForm() {
      this.$router.push({ name: 'user-details' });

    }
  },
};